import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import BeatLoader from "react-spinners/BeatLoader";
import { Spinner } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import ChatUser from "../components/ChatUser";
import { db } from "../utility/firebase";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  setDoc,
  doc,
} from "firebase/firestore";
import { apiUrl, myFetchPost } from "../utility/index";


const delay = (delay) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res("finish");
    }, delay);
  });
};

export const ConversationList = (props) => {
  const {
    listItemId,
    phoneChat,
    currentUser,
    currentChatRoomId,
    setUnReadCounterHere,
  } = props;

  const navigate = useNavigate();

  const chatRoomPageSize = 10;

  /* chatRooms Listing */
  const [chatRooms, setChatRooms] = useState([]);
  const [chatRoomListingPage, setChatRoomListingPage] = useState(1);
  const [isInitialLoadingChatRooms, setIsInitialLoadingChatRooms] =
    useState(true);
  const [isLoadingMoreChatRooms, setIsLoadingMoreChatRooms] = useState(false);
  const [itemName, setItemName] = useState(null);

  /* get data for chatRoomListing */
  useEffect(() => {
    const limitSize = chatRoomPageSize * chatRoomListingPage;
    const chatRoomRef = collection(db, "chatRooms");
    let q = null;
    if (parseInt(listItemId) > 0) {
      q = query(
        chatRoomRef,
        where("activeMembers", "array-contains", currentUser.uid),
        where("itemInfo.itemId", '==', parseInt(listItemId)),
        orderBy("lastUpdatedTime", "desc"),
        limit(limitSize)
      );
    } else {
      q = query(
        chatRoomRef,
        where("activeMembers", "array-contains", currentUser.uid),
        orderBy("lastUpdatedTime", "desc"),
        limit(limitSize)
      );
    }

    /* subscribe to chatRoom List */
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const chatRoomList = [];
      let newMessages = 0;
      let itemName2 = null;

      let source = null; /* prevent unexpected refresh */

      querySnapshot.forEach((doc) => {
        source = doc.metadata.fromCache ? "local cache" : "server";
        //console.log("Data came from " + source);
        let msgList = doc.data({ serverTimestamps: "estimate" });
        itemName2 = msgList.itemInfo?.itemName;
        msgList.id = doc.id;
        msgList.sentUser =
          doc.data().membersInfo[
          doc.data().members.find((p) => p != currentUser.uid)
          ];
        chatRoomList.push(msgList);
        newMessages +=
          msgList.lastMessage.sentTo == currentUser.uid
            ? msgList.lastMessage.unReadCount
            : 0;
      });

      if (source == 'server') {
        setTimeout(() => {
          setDoc(
            doc(db, "user", currentUser.uid),
            {
              unReadCount: newMessages,
            },
            { merge: true }
          );
        }, 500);
        setUnReadCounterHere(newMessages);
        //console.log('chatRoomList.length: ' + chatRoomList.length)
        setChatRooms(chatRoomList);
        setItemName(itemName2);
        setIsInitialLoadingChatRooms(false);
        setIsLoadingMoreChatRooms(false);

      } else {
        if (chatRoomList.length != 1) { /* this is a workaround for the conversation list scroll flicker issue in desktop */
          setUnReadCounterHere(newMessages);
          //console.log('chatRoomList.length: ' + chatRoomList.length)
          setChatRooms(chatRoomList);
          setItemName(itemName2);
          setIsInitialLoadingChatRooms(false);
          setIsLoadingMoreChatRooms(false);
        }
      }

      if (itemName2 === null) {
        const requestData = {
          itemID: parseInt(listItemId),
        };
        currentUser
          .getIdToken()
          .then((token) => {
            myFetchPost(`${apiUrl}/chat/getiteminfo`, requestData, {
              Authorization: "Bearer " + token,
            })
              .then((data) => {
                if (data.result === "success") {
                  setItemName(data.itemData.itemName);
                } else {
                  throw new Error(data.message);
                }
              })
              .catch((err) => { });
          })
      }
    });

    return () => {
      unsubscribe();
    };
  }, [chatRoomListingPage, listItemId]);

  const fetchMoreChatRooms = () => {
    if (!isLoadingMoreChatRooms && !isInitialLoadingChatRooms) {
      setIsLoadingMoreChatRooms(true);
      delay(300).then(() => {
        setChatRoomListingPage((prevPage) => {
          return prevPage + 1;
        });

      })
    }
  };

  const selectUser = (chatRoomId) => {
    if (chatRoomId == currentChatRoomId) {
      if (parseInt(listItemId) > 0) {
        navigate(`/${chatRoomId}/${listItemId}/?${Math.floor(Math.random() * 9999999999999)}`);
      } else {
        navigate(`/${chatRoomId}?${Math.floor(Math.random() * 9999999999999)}`);
      }
    } else {
      if (parseInt(listItemId) > 0) {
        navigate(`/${chatRoomId}/${listItemId}`);
      } else {
        navigate(`/${chatRoomId}`);
      }
    }
  };

  let content = null;
  if (isInitialLoadingChatRooms) {
    content = (
      <div className="loadingSpinner">
        {phoneChat ? null : (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </div>
    );
  } else if (chatRooms.length > 0) {
    content = (
      <InfiniteScroll
        dataLength={chatRooms.length}
        next={fetchMoreChatRooms}
        hasMore={true}
        loader={
          <div className="loadingMoreChatRooms">
            <BeatLoader
              color="#333"
              loading={isLoadingMoreChatRooms}
              size={13}
            />
          </div>
        }
        scrollableTarget="conversationListscrollableDiv"
      >
        {chatRooms.map((data, index) => {
          return (
            <ChatUser
              listItemId={listItemId}
              chatRoomData={data}
              index={index}
              selectUser={selectUser}
              currentUser={currentUser}
              lastUpdateSeconds={data.lastUpdatedTime.seconds}
              selectedChatUser={currentChatRoomId == data.id ? true : false}
              key={data.id}
            />
          );
        })}
      </InfiniteScroll>
    );
  } else {
    content = (
      <div className="emptyConversationList">
        <i className="bi bi-card-text"></i>
        <div>未有對話</div>
      </div>
    );
  }

  let itemMessageList = null;
  if (itemName != null && listItemId != undefined) {
    itemMessageList = <div className="itemMessageListWrap">
      <div className="itemMessageListText"><span dangerouslySetInnerHTML={{ __html: `"${itemName}" 的交易對話, 你可選擇交易對象, 查看對話, 完成交易並作出評價。` }} /></div>
    </div>
  }

  return (
    <div className="conversationList" id="conversationListscrollableDiv">
      {itemMessageList}
      {content}
    </div>
  );
};

export default ConversationList;
